import React from 'react';

import Error from 'components/Error';

import IconListItem from './components/IconListItem';
import type { IconListProps } from './interfaces';
import { Wrapper } from './styled';

const IconList: React.FC<IconListProps> = ({
  items,
  selected,
  multi,
  name,
  iconSize = 50,
  error,
  errorLabelProps,
  ...rest
}) => (
  <Wrapper {...rest}>
    {items.map(item => (
      <IconListItem
        key={item.value}
        {...item}
        name={name}
        selectionType={multi ? 'radio' : 'checkbox'}
        iconSize={item.iconSize || iconSize}
        selected={
          Array.isArray(selected) ? selected.indexOf(item.value) > -1 : item.value === selected
        }
      />
    ))}
    {error && <Error {...errorLabelProps}>{error}</Error>}
  </Wrapper>
);

export default IconList;
